<!-- Import Orders Page -->
<div class="import-container">
  <!-- Top section: warning + form + pickup -->
  <div class="import-top-row">
    <!-- LEFT SIDE -->
    <div class="import-left">
      <!-- Red warning + Get Template button -->
      <div class="import-template-container">
        <!-- Red bilingual warning text box -->
        <div class="import-warning-box">
          <div class="import-warning-text">
            <span>{{ "app.misc.importNote" | translate }}</span
            ><br />
            <span>{{ "app.misc.importDoc" | translate }}</span>
          </div>
        </div>

        <!-- Get Template button -->
        <button
          mat-raised-button
          color="primary"
          (click)="getTemplate()"
          style="height: 52px; display: flex; align-items: center; padding: 0 16px"
        >
          <mat-icon style="margin-right: 6px">download</mat-icon>
          <span>{{ "app.importOrders.getTemplate" | translate }}</span>
        </button>
      </div>

      <!-- Batch Shipments checkbox -->
      @if (batchShipmentsAllowed) {
        <div class="section-header-row">
          <mat-checkbox
            [(ngModel)]="isBatchEnabled"
            color="primary"
            (change)="toggleBatch($event)"
            class="nowrap-checkbox"
          >
            {{ "app.importOrders.batchShipments" | translate: { default: "" } }}
          </mat-checkbox>
          <span style="color: darkgreen">NOTE: {{ "app.importOrders.note" | translate }}</span>
        </div>
      }

      <!-- Description, Carrier, Email -->
      @if (batchShipmentsAllowed) {
        <div class="import-form-row" [class.disabled-section]="!isBatchEnabled" required>
          <mat-form-field appearance="outline" class="import-form-field">
            <mat-label>
              {{ "app.importOrders.description" | translate }}
              <span class="required-asterisk">*</span>
            </mat-label>
            <input matInput [(ngModel)]="batchDescription" />
          </mat-form-field>
          <!-- Carrier select -->
          <mat-form-field appearance="outline" class="import-form-field">
            <mat-label>{{ "app.importOrders.carrier" | translate }}</mat-label>
            <mat-select id="batchCarrier" [(ngModel)]="batchCarrier" (selectionChange)="onCarrierChanged()" [attr.aria-label]="'app.importOrders.carrier' | translate">
              @for (c of carriers; track c) {
                <mat-option [value]="c">
                  {{ c }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
          <!-- ServiceType select -->
          <div class="service-type-container">
            <mat-form-field appearance="outline" class="service-type-field">
              <mat-label>{{ "app.importOrders.serviceType" | translate }}</mat-label>
              <mat-select id="batchServiceType" [(ngModel)]="batchServiceType" [attr.aria-label]="'app.importOrders.serviceType' | translate">
                @for (s of filteredServiceTypes; track s) {
                  <mat-option [value]="s.ServiceType">
                    {{ s.ServiceType }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
          <mat-form-field appearance="outline" class="import-form-field" required>
            <mat-label>
              {{ "app.importOrders.emailForReport" | translate }}
              <span class="required-asterisk">*</span>
            </mat-label>
            <input matInput [(ngModel)]="batchEmail" />
          </mat-form-field>
        </div>
      }

      @if (isBatchEnabled && batchShipmentsAllowed) {
        <span class="import-form-row" style="color: darkred"
          >ATTENTION: {{ "app.batchShipments.note" | translate }}</span
        >
      }

      <!-- File upload controls -->
      <app-upload-orders
        [isBatchEnabled]="isBatchEnabled"
        [batchDescription]="batchDescription"
        [batchCarrier]="batchCarrier"
        [(batchServiceType)]="batchServiceType"
        [batchEmail]="batchEmail"
      >
      </app-upload-orders>
    </div>

    <!-- RIGHT SIDE -->
    <!-- <div class="import-right">
    <mat-card class="pickup-card" [class.disabled-section]="!isBatchEnabled || !isPickupEnabled">
      <div class="pickup-card__header">
        <mat-checkbox [(ngModel)]="isPickupEnabled" color="primary" [disabled]="!isBatchEnabled">
          {{ 'app.importOrders.createPickups' | translate }}
        </mat-checkbox>
      </div>

      <div class="pickup-card__content">
        <mat-form-field appearance="outline" class="pickup-field small-field">
          <mat-label>{{ 'app.importOrders.pickupDate' | translate }}</mat-label>
          <input matInput [matDatepicker]="pickerDate" [(ngModel)]="pickupDate" />
          <mat-datepicker-toggle matSuffix [for]="pickerDate"></mat-datepicker-toggle>
          <mat-datepicker #pickerDate></mat-datepicker>
        </mat-form-field>

        <div class="pickup-time-row">
          <mat-form-field appearance="outline" class="pickup-field pickup-time small-field">
            <mat-label>{{ 'app.importOrders.readyTime' | translate }}</mat-label>
            <input matInput [(ngModel)]="pickupReadyTime" placeholder="09:00" />
          </mat-form-field>

          <mat-form-field appearance="outline" class="pickup-field pickup-time small-field">
            <mat-label>{{ 'app.importOrders.closeTime' | translate }}</mat-label>
            <input matInput [(ngModel)]="pickupCloseTime" placeholder="17:00" />
          </mat-form-field>
        </div>

        <mat-form-field appearance="outline" class="pickup-field small-field">
          <mat-label>{{ 'app.importOrders.customerReference' | translate }}</mat-label>
          <textarea matInput rows="1" [(ngModel)]="pickupCustomerRef"></textarea>
        </mat-form-field>

        <mat-form-field appearance="outline" class="pickup-field small-field">
          <mat-label>{{ 'app.importOrders.pickupInstructions' | translate }}</mat-label>
          <textarea matInput rows="2" [(ngModel)]="pickupInstructions"></textarea>
        </mat-form-field>
      </div>
    </mat-card>
  </div> -->
  </div>

  <!-- Divider -->
  <hr class="separator" />

  <!-- History Header -->
  @if (batchShipmentsAllowed) {
    <div class="history-header-row">
      <div class="history-title">
        {{ "app.importOrders.batchShipmentsHistory" | translate }}
      </div>
      <button mat-stroked-button color="primary" class="refresh-btn" (click)="refresh()">
        <mat-icon class="refresh-icon">autorenew</mat-icon>
        <span>{{ "app.importOrders.refresh" | translate }}</span>
      </button>
    </div>
  }

  <!-- History Table -->
  @if (batchShipmentsAllowed) {
    <div class="history-table-wrapper">
      <table mat-table [dataSource]="historyRows" class="mat-elevation-z1 history-table">
        <!-- Batch Date -->
        <ng-container matColumnDef="IMH_ImportedDate">
          <th mat-header-cell *matHeaderCellDef>{{ "app.importOrders.batchDate" | translate }}</th>
          <td mat-cell *matCellDef="let row">{{ row.IMH_ImportedDate | date: "yyyy-MM-dd" }}</td>
        </ng-container>
        <!-- Description -->
        <ng-container matColumnDef="IMH_Description">
          <th mat-header-cell *matHeaderCellDef>{{ "app.importOrders.description" | translate }}</th>
          <td mat-cell *matCellDef="let row">{{ row.IMH_Description }}</td>
        </ng-container>
        <!-- Carrier -->
        <ng-container matColumnDef="IMH_Carrier">
          <th mat-header-cell *matHeaderCellDef>{{ "app.importOrders.carrier" | translate }}</th>
          <td mat-cell *matCellDef="let row">{{ row.IMH_Carrier }}</td>
        </ng-container>
        <!-- Service -->
        <ng-container matColumnDef="IMH_ServiceType">
          <th mat-header-cell *matHeaderCellDef>{{ "app.importOrders.serviceType" | translate }}</th>
          <td mat-cell *matCellDef="let row">{{ row.IMH_ServiceType }}</td>
        </ng-container>
        <!-- Email -->
        <ng-container matColumnDef="IMH_Email">
          <th mat-header-cell *matHeaderCellDef>{{ "app.importOrders.email" | translate }}</th>
          <td mat-cell *matCellDef="let row">{{ row.IMH_Email }}</td>
        </ng-container>
        <!-- Order Count -->
        <ng-container matColumnDef="IMH_OrderCount">
          <th mat-header-cell *matHeaderCellDef>{{ "app.importOrders.orderCount" | translate }}</th>
          <td mat-cell *matCellDef="let row">{{ row.IMH_OrderCount }}</td>
        </ng-container>
        <!-- Success Count -->
        <ng-container matColumnDef="IMH_ImportSuccessCount">
          <th mat-header-cell *matHeaderCellDef>{{ "app.importOrders.successCount" | translate }}</th>
          <td mat-cell *matCellDef="let row">{{ row.IMH_ImportSuccessCount }}</td>
        </ng-container>
        <!-- Failure Count -->
        <ng-container matColumnDef="IMH_ImportFailureCount">
          <th mat-header-cell *matHeaderCellDef>{{ "app.importOrders.failureCount" | translate }}</th>
          <td mat-cell *matCellDef="let row">{{ row.IMH_ImportFailureCount || 0 }}</td>
        </ng-container>
        <!-- Actions -->
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef>
            {{ "app.importOrders.actions" | translate }}
          </th>
          <td mat-cell *matCellDef="let row" class="actions-cell">
            <button mat-raised-button color="primary" class="row-action-btn" (click)="waybills(row)">
              <mat-icon class="btn-icon">local_shipping</mat-icon>
              {{ "app.importOrders.waybills" | translate }}
            </button>
            <button mat-raised-button color="primary" class="row-action-btn" (click)="report(row)">
              <mat-icon class="btn-icon">description</mat-icon>
              {{ "app.importOrders.report" | translate }}
            </button>
            <button mat-raised-button color="primary" class="row-action-btn" (click)="reprocess(row)">
              <mat-icon class="btn-icon">autorenew</mat-icon>
              {{ "app.importOrders.reprocess" | translate }}
            </button>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns" class="history-header-row-table"></tr>
        <tr
          mat-row
          *matRowDef="let row; columns: displayedColumns"
          class="history-data-row"
          [class.failure-row]="row.IMH_ImportFailureCount > 0"
        ></tr>
      </table>
    </div>
  }
</div>

<!-- Overlay when processing -->
@if (isProcessing) {
  <app-processing-overlay [message]="'app.misc.processing' | translate"> </app-processing-overlay>
}
